import FloatingWrapper from '~/components/FloatingWrapper';
import ScrollTop from '~/components/ScrollTop';
import StickyCartBar from '~/components/StickyCartBar';
import ProductFilters from '~/domains/products/ProductFilters';
import { useSearchProducts } from '~/domains/products/queries/useSearchProducts';
import EmptyProductSearch from '~/domains/search/EmptyProductSearch';
import { useRouterQueryByKey } from '~/hooks/url';

import { SearchResultProductList } from './SearchResultProductList';
import SearchTopBanner from './SearchTopBanner';

export function SearchContainer() {
  const searchText = useRouterQueryByKey('searchText', 'string');

  const { pages, total, fetchNextPage, hasNextPage } = useSearchProducts({
    enabled: Boolean(searchText),
  });

  return (
    <section>
      <ProductFilters />
      <SearchTopBanner />
      {!pages?.length ? (
        <EmptyProductSearch />
      ) : (
        <SearchResultProductList
          totalCount={total}
          data={pages || []}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          sortType="SCORE"
        />
      )}
      <FloatingWrapper hasStickyBar>
        <ScrollTop />
        <StickyCartBar placementName="검색결과" className="!-mr-0 !mb-0" />
      </FloatingWrapper>
    </section>
  );
}
